import {React, useEffect, useState, Fragment} from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import {Paper, Grid, Typography, TextField, MenuItem, Zoom, Table, TableBody, TableHead, TableContainer, TableCell, TableRow, 
        Fab, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Switch, Checkbox, IconButton, CircularProgress} from '@material-ui/core/'
import {DatePicker} from '@material-ui/pickers';        
import AddIcon from '@material-ui/icons/Add';
import {authFetch, logout} from '../../auth';


const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.main,
      padding: 3
    },
    body: {
      fontSize: 14,
      color: theme.palette.primary.dark,
      padding: 5
    },
  }))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: theme.spacing(2)
    },
    darkText: {
        color: theme.palette.primary.main
    },
    sectionTitle: {
        marginBottom: 10,
        backgroundColor: theme.palette.secondary.light,
        borderRadius: 3,
        color: theme.palette.primary.dark
    },
    componentTitle: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.secondary.main,
        padding: 2,
        borderRadius: 10,
        marginBottom: theme.spacing(1)
    },
    formPaper: {
        padding: theme.spacing(3),
        color: theme.palette.primary.main,
        "> * + *": {
            marginTop: theme.spacing(5)
        }
    }, 
    formRow: {
        width: "100%",       
        maxHeight: "50%",        
    },
    labelText: {
        color: theme.palette.primary.main,
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 16 
    },
    dialogContent: {
        fontSize: 14,
        color: theme.palette.primary.main,
    },
    dialogTitle: {
        fontSize: 14,
        color: theme.palette.primary.main,
        fontWeight: 'normal'
    },
    formText: {
        fontSize: 14,
        color: theme.palette.primary.main,
        textAlign: "left",
        marginLeft: theme.spacing(1)
    },
    formDefined: {
        backgroundColor: theme.palette.secondary.light,        
    },
    formItem: {
        fontSize: theme.typography.subtitle1.fontSize,
        fontWeight: 'normal',
        color: theme.palette.primary.dark
    },
    formDateText: {
        fontSize: 14,
        color: theme.palette.primary.main,
        textAlign: "left",
    },
    formItemNoPadding: {
        padding: 0
    },
    uploadButton : {
        fontSize: 14,
        [theme.breakpoints.down('xs')]: {
          fontSize: 8,
        },
    },
    searchButton:{
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.secondary.main,
        borderRadius: 8,
        fontSize: 29,
        "&:hover": {
            backgroundColor: theme.palette.primary.dark,            
        },                
    },
  }));
  
export default function Summary(props) {
    const classes = useStyles();

    const [overcomeOffers, setOvercomeOffers] = useState([])

    useEffect (() => {
        document.title ="Ofertas por vencer usuarios no regulados";
        authFetch("/api/check-expiration-no-reg-offers?username=" + String(props.username)).then(response => {
            if (response.status === 422){
                    logout()
                    return null
                }
                return response.json()
            }).then(response => {
                if (response && response.offers){
                    setOvercomeOffers(response.offers)                
                }
            })

    }, [])

    return (
        <div className={classes.root}>

            <Zoom in timeout={800}>
            {
       
                <Grid container justify="space-evenly">                
                    <Grid item xs={9}>
                        <Typography variant="subtitle1" className={classes.sectionTitle}>Lista de ofertas por vencer</Typography>
                        <TableContainer component={Paper} style={{marginTop: 10}}>
                            <Table aria-label="markets table">
                                <TableHead>
                                <TableRow>
                                    <StyledTableCell align="center">Código de cliente</StyledTableCell>
                                    <StyledTableCell align="center">Nombre</StyledTableCell>
                                    <StyledTableCell align="center">Días restantes</StyledTableCell>
                                    <StyledTableCell align="center">Fecha Final</StyledTableCell>                                
                                </TableRow>
                                </TableHead>
                                <TableBody>    
                                    {
                                        overcomeOffers.map((offer) => (
                                            <StyledTableRow>
                                                <StyledTableCell align="center">{offer.client_code}</StyledTableCell>
                                                <StyledTableCell align="center">{offer.client_name}</StyledTableCell>
                                                <StyledTableCell align="center" style={ offer.remaining_days < 0 ? {background: '#FB9187'} : {}}>{offer.remaining_days < 0 ? 'VENCIDA' : offer.remaining_days}</StyledTableCell>
                                                <StyledTableCell align="center">{new Date(offer.finish_date).toLocaleString('en-GB', {day: "2-digit", month: "2-digit", year: "numeric"})}</StyledTableCell>
                                            </StyledTableRow>
                                        ))
                                    }                                                                                                                                   
                                </TableBody>
                            </Table>
                        </TableContainer> 
                    </Grid>
                                                                                                    
                </Grid>
            }
            </Zoom>    
        </div>
    );
}